const StarIcon = (props: any) => (
	<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_1762_13303)">
			<path
				d="M10 19.3132L5.82 21.5102L7 14.6282L2 9.75423L8.91 8.75023L12 2.49023L15.09 8.75023L22 9.75423L19 12.6782"
				stroke="#333333"
				strokeWidth={2}
				strokeMiterlimit={10}
				strokeLinecap="square"
			/>
			<path d="M23 22H14" stroke="#333333" strokeWidth={2} strokeMiterlimit={10} strokeLinecap="square" />
			<path d="M23 17H14" stroke="#333333" strokeWidth={2} strokeMiterlimit={10} strokeLinecap="square" />
		</g>
		<defs>
			<clipPath id="clip0_1762_13303">
				<rect width={24} height={24} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export default StarIcon;
